const map = {
	"./10ALabs.jpg": 8967,
	"./align.jpg": 9656,
	"./americanBTC.jpg": 4516,
	"./atlasInvest.jpg": 3121,
	"./copia.jpg": 4807,
	"./dimensional.jpg": 5012,
	"./electronx.jpg": 8485,
	"./engageli.jpg": 8539,
	"./futureSecureAi.jpg": 9495,
	"./hedral.jpg": 3567,
	"./insitro.jpg": 6165,
	"./ionic.jpg": 6477,
	"./kai.jpg": 5966,
	"./nirvana.jpg": 4032,
	"./novaCredit.jpg": 238,
	"./nurl.jpg": 4934,
	"./pioneerLabs.jpg": 3857,
	"./prosights.jpg": 8852,
	"./reserv.jpg": 5024,
	"./rhino.jpg": 5321,
	"./spacial.jpg": 8282,
	"./spade.jpg": 3244,
	"./tabflows.jpg": 5355,
	"./treasureTrove.jpg": 5720,
	"./truvo.jpg": 6557,
	"./tulu.jpg": 2955,
	"./turnout.jpg": 5980,
	"./vegaClaims.jpg": 7615
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7329;